import { OrderedAsyncEnumerable } from "../OrderedAsyncEnumerable.js";
export const orderDescending = (source, comparer) => {
    return OrderedAsyncEnumerable.generate(source, (x) => x, false, comparer);
};
